import React from 'react';
import MelilloSensorAnalysis from './Melillo/SensorAnalysis';
import MelilloDevelopmentalHistory from './Melillo/DevelopmentalHistory';
import MelilloHemisphericAnalysis from './Melillo/HemisphericAnalysis';
import MelilloFollowUp from './Melillo/FollowUp';
import MelilloCoreStabilityAssessment, {
    RequiredFields as MelilloCoreStabilityAssessmentRequiredFields,
    ValidationFunc as MelilloCoreStabilityAssessmentValidationFunc
} from './Melillo/CoreStabilityAssessment';
import MelilloPrimitiveReflexAssessment, { RequiredFields as MelilloPrimitiveReflexAssessmentRequiredFields } from './Melillo/PrimitiveReflexAssessment';
import KindyRooDevelopmentalHistory from './KindyRoo/DevelopmentalHistory';
import KindyRooHemisphericAnalysis from './KindyRoo/HemisphericAnalysis';
import KindyRooBGQuestionnaire from './KindyRooBG/Questionnaire';
import KindyRooAUMedicalInformation, {
    RequiredFields as KindyRooAUMedicalInformationRequiredFields,
    ValidationFunc as KindyRooAUMedicalInformationValidationFunc
} from './KindyRooAU/MedicalInformation';
import ArtKMedicalInformation, {
    RequiredFields as ArtKMedicalInformationRequiredFields,
    ValidationFunc as ArtKMedicalInformationValidationFunc
} from './ArtK/MedicalInformation';

const Components = {
    MelilloSensorAnalysis: { component: MelilloSensorAnalysis },
    MelilloDevelopmentalHistory: { component: MelilloDevelopmentalHistory },
    MelilloHemisphericAnalysis: { component: MelilloHemisphericAnalysis },
    MelilloFollowUp: { component: MelilloFollowUp },
    MelilloCoreStabilityAssessment: {
        component: MelilloCoreStabilityAssessment,
        requiredFields: MelilloCoreStabilityAssessmentRequiredFields,
        validationFunc: MelilloCoreStabilityAssessmentValidationFunc
    },
    MelilloPrimitiveReflexAssessment: {
        component: MelilloPrimitiveReflexAssessment,
        requiredFields: MelilloPrimitiveReflexAssessmentRequiredFields
    },

    KindyRooDevelopmentalHistory: { component: KindyRooDevelopmentalHistory },
    KindyRooHemisphericAnalysis: { component: KindyRooHemisphericAnalysis },
    KindyRooBGQuestionnaire: { component: KindyRooBGQuestionnaire },
    KindyRooAUMedicalInformation: {
        component: KindyRooAUMedicalInformation,
        requiredFields: KindyRooAUMedicalInformationRequiredFields,
        validationFunc: KindyRooAUMedicalInformationValidationFunc
    },
    ArtKMedicalInformation: {
        component: ArtKMedicalInformation,
        requiredFields: ArtKMedicalInformationRequiredFields,
        validationFunc: ArtKMedicalInformationValidationFunc
    }
};

export default (formResponse, currentFormValues, changeFormValue) => {
    // component does exist
    if (formResponse) {
        const formName = formResponse.form.name;
        if (typeof Components[formName] !== 'undefined') {
            const { component, requiredFields, validationFunc } = Components[formName];

            return {
                component: React.createElement(component, {
                    resourcesNamespace: `form.${formName}.resources`,
                    isReadOnly: formResponse.status.id === 3, //Final
                    childId: formResponse.childId,
                    currentFormValues,
                    changeFormValue
                }),
                requiredFields,
                validationFunc
            };
        }
    }
    // component doesn't exist yet
    return {
        component: React.createElement(
            () => <div>The form has not been created yet.</div>
        ),
        requiredFields: null,
        validationFunc: null
    };
};